import { Typography } from '@mui/material';
import { SuppliersContext } from 'Context/SuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { useContext } from 'react';

export const Title = () => {
  const { suppliersId } = useContext(SuppliersContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;

  const titleHandler = () => {
    switch (suppliersId) {
      case 0:
        return dictionary.therapy.title;
      default:
        return '';
    }
  };

  return (
    <Typography
      variant='h3'
      component='h1'
      sx={{
        textAlign: 'center',
      }}
    >
      {dictionary.title} {titleHandler()}
    </Typography>
  );
};
